import { useCallback } from "react";

import useTranslations from "@/shared/lang/useTranslations";

import {
  amountPrecision,
  formatAmount,
  type AmountPrecision,
  type PairPrecision,
} from "../utils/cryptoSwapFormat";

/** Amount → text for interpolation into a translated sentence, at the module's precision rules. */
export function useAmountFormatter(pair?: PairPrecision | null) {
  const { activeLanguage } = useTranslations("cryptoSwaps");

  return useCallback(
    (value: string, currency: string, precision?: AmountPrecision) =>
      formatAmount(value, activeLanguage, precision ?? amountPrecision(currency, pair)),
    [activeLanguage, pair],
  );
}
